import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/btn_top.svg'
import _imports_1 from '@/assets/icon-change.svg'
import _imports_2 from '@/assets/icon-road.svg'
import _imports_3 from '@/assets/icon-area.svg'
import _imports_4 from '@/assets/icon-train.svg'
import _imports_5 from '@/assets/area/horizontal-blur.png'
import _imports_6 from '@/assets/icon-hint.svg'
import _imports_7 from '@/assets/icon-download.svg'


const _hoisted_1 = { class: "jr-flex jr-w-full jr-items-center jr-justify-between" }
const _hoisted_2 = { class: "jr-flex jr-items-center jr-justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "btn top"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-inline-block jr-mr-2",
  src: _imports_1,
  alt: "sync"
}, null, -1)
const _hoisted_6 = { class: "jr-inline-block jr-text-left jr-align-middle jr-font-bold jr-text-s-1" }
const _hoisted_7 = {
  key: 0,
  class: "jr-inline-block jr-align-middle jr-mr-5",
  src: _imports_2,
  alt: "road"
}
const _hoisted_8 = {
  key: 1,
  class: "jr-inline-block jr-align-middle jr-mr-5",
  src: _imports_3,
  alt: "area"
}
const _hoisted_9 = {
  key: 2,
  class: "jr-inline-block jr-align-middle jr-mr-5",
  src: _imports_4,
  alt: "train"
}
const _hoisted_10 = { class: "jr-text-xl jr-font-bold jr-inline-block jr-align-top" }
const _hoisted_11 = {
  key: 1,
  class: "jr-py-1"
}
const _hoisted_12 = { class: "jr-block" }
const _hoisted_13 = { class: "jr-truncate jr-align-middle jr-max-w-xs jr-inline-block jr-text-primary jr-font-medium jr-mr-5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "jr-inline-block jr-text-s" }
const _hoisted_17 = { class: "jr-relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-absolute jr-max-h-full jr-right-0 jr-top-0",
  src: _imports_5,
  alt: "blur"
}, null, -1)
const _hoisted_19 = {
  key: 2,
  class: "jr-py-1"
}
const _hoisted_20 = { class: "jr-flex jr-items-center jr-px-7.5 jr-py-2 jr-border-l jr-border-dashed jr-border-blue-light-soft" }
const _hoisted_21 = { class: "jr-mr-8 jr-text-base jr-font-medium jr-text-primary" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "jr-text-s" }, "路線利用者の居住地・勤務地分布", -1)
const _hoisted_23 = {
  key: 3,
  class: "jr-py-1"
}
const _hoisted_24 = { class: "jr-flex jr-items-center jr-px-7.5 jr-py-2 jr-border-l jr-border-dashed jr-border-blue-light-soft" }
const _hoisted_25 = { class: "jr-mr-8 jr-text-base jr-font-medium jr-text-primary" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "jr-text-s" }, "駅利用人流", -1)
const _hoisted_27 = {
  key: 4,
  class: "jr-py-1"
}
const _hoisted_28 = { class: "jr-px-7.5 jr-border-l jr-border-dashed jr-border-blue-light-soft" }
const _hoisted_29 = { class: "jr-flex jr-items-center" }
const _hoisted_30 = { class: "jr-mr-8 jr-text-base jr-font-medium jr-text-primary" }
const _hoisted_31 = { class: "jr-inline-block jr-text-s" }
const _hoisted_32 = { class: "jr-relative" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-absolute jr-max-h-full jr-right-0 jr-top-0",
  src: _imports_5,
  alt: "blur"
}, null, -1)
const _hoisted_34 = { class: "detail_page_wrapper" }
const _hoisted_35 = {
  key: 0,
  class: "detail_page"
}
const _hoisted_36 = { class: "selected_road" }
const _hoisted_37 = { class: "road-names jr-text-center jr-text-black jr-font-bold jr-text-xl" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "suffix jr-font-normal jr-text-sm jr-text-primary" }, "(選択区間)", -1)
const _hoisted_39 = {
  key: 1,
  class: "filter_list jr-flex jr-justify-center jr-mb-51px"
}
const _hoisted_40 = {
  key: 0,
  class: "jr-m-1"
}
const _hoisted_41 = { class: "jr-h-6 jr-leading-6 focus:jr-outline-none jr-bg-gray-light jr-border-gray-light jr-px-3 jr-rounded jr-text-center jr-text-xs jr-text-black-light" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, "曜日別：", -1)
const _hoisted_43 = {
  key: 1,
  class: "jr-m-1"
}
const _hoisted_44 = { class: "jr-h-6 jr-leading-6 focus:jr-outline-none jr-bg-gray-light jr-border-gray-light jr-px-3 jr-rounded jr-text-center jr-text-xs jr-text-black-light" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "平日・土日祝日：", -1)
const _hoisted_46 = {
  key: 2,
  class: "jr-m-1"
}
const _hoisted_47 = { class: "jr-h-6 jr-leading-6 focus:jr-outline-none jr-bg-gray-light jr-border-gray-light jr-px-3 jr-rounded jr-text-center jr-text-xs jr-text-black-light" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "時間帯：", -1)
const _hoisted_49 = { class: "jr-flex" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "hint"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-inline-block jr-align-text-top jr-mr-1 jr-w-3.5 jr-h-3.5",
  src: _imports_7,
  alt: "download"
}, null, -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" ダウンロード ")
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AreaFilterBadge = _resolveComponent("AreaFilterBadge")!
  const _component_RailwayFilterBadge = _resolveComponent("RailwayFilterBadge")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fix-header jr-fixed jr-z-20 jr-top-0 jr-left-0 jr-w-full jr-flex jr-bg-white jr-items-center jr-min-w-main jr-shadow-md jr-h-filter-nav", { 'jr-mt-0': _ctx.isCapturing }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["jr-bg-white jr-text-white jr-py-4.45 jr-px-6 jr-cursor-pointer", { 'jr-hidden': _ctx.isCapturing }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleGoTop && _ctx.handleGoTop(...args)))
        }, _hoisted_4, 2),
        (_ctx.isReport)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass(["to-top-btn jr-cursor-pointer", { 'jr-hidden': _ctx.isCapturing }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleGotoRoad && _ctx.handleGotoRoad(...args)))
            }, [
              _hoisted_5,
              _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$route.meta.description) + "変更", 1)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["jr-bg-white jr-text-blue-bold jr-pl-15 jr-pr-7.5", { 'jr-hidden': _ctx.isCapturing }])
        }, [
          (_ctx.isRoad)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.isArea)
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.isRailway)
            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.$route.meta.description), 1)
        ], 2),
        (_ctx.$route.path.indexOf('area_report') >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["jr-px-7.5 jr-border-l jr-border-blue-light-soft", {'jr-border-dashed': !_ctx.isCapturing}])
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h1", _hoisted_13, [
                    (_ctx.prefLabels.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.prefLabels), 1))
                      : _createCommentVNode("", true),
                    (_ctx.prefLabels.length === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "エリア選択"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.areaPage), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.isShowAreaFilterNav)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{ 'badge-contents': !_ctx.isCapturing }, "jr-flex jr-mt-1.5 jr-overflow-x-auto"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge, index) => {
                          return (_openBlock(), _createBlock(_component_AreaFilterBadge, {
                            class: "badge-box",
                            key: index,
                            title: badge.title,
                            content: badge.content
                          }, null, 8, ["title", "content"]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.isHeatmap)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass([{ 'badge-contents': !_ctx.isCapturing }, "jr-flex jr-mt-1.5 jr-overflow-x-auto"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heatmapBadges, (badge, index) => {
                          return (_openBlock(), _createBlock(_component_AreaFilterBadge, {
                            class: "badge-box",
                            key: index,
                            title: badge.title,
                            content: badge.content
                          }, null, 8, ["title", "content"]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true),
                  _hoisted_18
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$route.path.indexOf('railway_station') >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.selectedRailwayLine), 1),
                _hoisted_22
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$route.path.indexOf('railway_polygon') >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h1", _hoisted_25, _toDisplayString(_ctx.selectedRailwayLine) + " (" + _toDisplayString(_ctx.selectedRailwayStation) + ")", 1),
                _hoisted_26
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$route.path.indexOf('railway_report') >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("h1", _hoisted_30, _toDisplayString(_ctx.selectedRailwayLine) + " (" + _toDisplayString(_ctx.selectedRailwayStation) + ")", 1),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.railwayPage), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'badge-contents': !_ctx.isCapturing }, "jr-flex jr-mt-1.5 jr-overflow-x-auto"])
                  }, [
                    (_ctx.$route.path.indexOf('railway_report/comparison') >= 0)
                      ? (_openBlock(), _createBlock(_component_RailwayFilterBadge, {
                          key: 0,
                          class: "badge-box",
                          data: _ctx.railwayTimeRange
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true),
                    (_ctx.$route.path.indexOf('railway_report/comparison') >= 0 || _ctx.$route.path.indexOf('railway_report/animation') >= 0)
                      ? (_openBlock(), _createBlock(_component_RailwayFilterBadge, {
                          key: 1,
                          class: "badge-box",
                          data: _ctx.railwayWeek
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true),
                    (_ctx.$route.path.indexOf('railway_report/heatmap') >= 0)
                      ? (_openBlock(), _createBlock(_component_RailwayFilterBadge, {
                          key: 2,
                          class: "badge-box",
                          data: _ctx.railwayTransportation
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true),
                    (_ctx.$route.path.indexOf('railway_report/heatmap') >= 0)
                      ? (_openBlock(), _createBlock(_component_RailwayFilterBadge, {
                          key: 3,
                          class: "badge-box",
                          data: _ctx.railwayResident
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _hoisted_33
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          (_ctx.isReportPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _withDirectives(_createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_ctx.roadTitles) + " ", 1),
                    _hoisted_38
                  ])
                ], 512), [
                  [_vShow, !_ctx.isCapturing]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'jr-ml-5': !_ctx.isCapturing }, "page_name"])
                }, _toDisplayString(_ctx.pageName), 3)
              ]))
            : _createCommentVNode("", true),
          (_ctx.filters && _ctx.isReportPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                (
        (_ctx.$store.state.chart.activeFilterType === _ctx.CheckboxFilterType.DayDiffer && _ctx.$router.currentRoute.value.fullPath === '/report/graph') && _ctx.dayLabel.length > 0 ||
        (_ctx.$router.currentRoute.value.fullPath === '/report/same_day_series') && _ctx.dayLabel.length > 0 ||
        (_ctx.$router.currentRoute.value.fullPath === '/report/one_hour_series') && _ctx.dayLabel.length > 0
      )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("span", null, _toDisplayString(_ctx.dayLabel), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.chart.activeFilterType === _ctx.CheckboxFilterType.WeekDiffer && _ctx.weekLabel !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", null, _toDisplayString(_ctx.weekLabel), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.timeLabel.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("span", null, _toDisplayString(_ctx.timeLabel), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        (_ctx.$route.meta.hasHint)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "data-html2canvas-ignore": "true",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickHint && _ctx.onClickHint(...args))),
              class: "jr-mr-6 jr-outline-0"
            }, _hoisted_51))
          : _createCommentVNode("", true),
        (_ctx.showDownload === true)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickDownload && _ctx.onClickDownload(...args))),
              class: _normalizeClass(["btn_download jr-mr-5 jr-self-center jr-top-7.5 jr-right-8 jr-h-7.5 jr-bg-white jr-px-4.5 jr-border-1 jr-border-gray-medium jr-w-35 jr-rounded-3xl jr-text-center jr-text-s-2 jr-content-end jr-text-black-light", { 'jr-hidden': _ctx.isCapturing }])
            }, _hoisted_54, 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}